import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/Forgot_Password";
import LandingPage from "./pages/Landing_Page";
import ResetPassword from "./pages/Reset_Password";
import AdminDashboard from "./pages/AdminDashboard";
import { ToastContainer } from "react-toastify";
import Sports from "./pages/Sports";
import LiveMatches from "./pages/sports/live-matches";
import UpcomingMatches from "./pages/sports/upcoming-matches";
import Highlights from "./pages/sports/highlights";
import Players from "./pages/sports/players";
import Clubs from "./pages/sports/clubs";
import ClubPlayers from "./pages/sports/club-players";
import CoachDetail from "./pages/sports/coach-detail";
import GameShows from "./pages/GameShows";
import GameShowDetail from "./pages/game-shows/GameShowDetails";
import Awards from "./pages/Awards";
import Voting from "./pages/Voting";
import VotingDetails from "./pages/voting/VotingDetails";
import Lifestyle from "./pages/Lifestyle";
import Magazine from "./pages/Magazine";
import MagazineViewer from "./pages/MagazineViewer";
import LeagueTables from "./pages/sports/leagueTable";
import Stats from "./pages/Stats";
import SubscriptionPlans from "./pages/SubscriptionPlans";
import Profile from "./pages/Profile";
import News from "./pages/News";
import NewsDetail from "./pages/news/NewsDetail";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import BuyVotes from "./pages/BuyVotes";
import axios from "axios";
// DESAC Sports imports
import DesacSports from "./pages/desac_sports/DesacSports";
import RisingStarsRegistration from "./pages/desac_sports/RisingStarsRegistration";
import RegistrationSuccess from "./pages/desac_sports/RegistrationSuccess";
import { checkSubscriptionStatus } from "./services/subscriptionService";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Add this ProtectedRoute component at the top of your file
const ProtectedRoute = ({ children, adminOnly = false }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasValidSubscription, setHasValidSubscription] = useState(false);
  const [error, setError] = useState(null);
  const isAuthenticated = !!localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");
  const referenceId = localStorage.getItem("referenceId");
  const selectedPlan = JSON.parse(localStorage.getItem("selectedPlan"));
  const navigate = useNavigate();

  useEffect(() => {

    setIsLoading(false);
    setHasValidSubscription(true);
    
    // const checkSubscription = async () => {
    //   if (!isAuthenticated) {
    //     setIsLoading(false);
    //     return;
    //   }
    //   if (isAuthenticated && !adminOnly) {
    //     try {
    //       const result = await checkSubscriptionStatus();
    //       console.log(result.status);
    //       if (result.message === "Invalid or expired token.") {
    //         return <Navigate to="/login" />;
    //       }
    //       setHasValidSubscription(result.isValid);
    //       setError(result.error);
    //     } catch (error) {
    //       setHasValidSubscription(false);
    //       setError("Failed to check subscription status");
    //     }
    //   } else {
    //     setHasValidSubscription(true); // Skip subscription check for admin routes
    //   }
    //   setIsLoading(false);
    // };
    // checkSubscription();
    // eslint-disable-next-line
  }, [isAuthenticated, adminOnly]);

  useEffect(() => {
    const referenceId = localStorage.getItem("referenceId"); // 🔑 poll from storage
    const selectedPlan = JSON.parse(localStorage.getItem("selectedPlan"));

    if (!referenceId) return; // nothing to verify

    const verifyPayment = async () => {
      try {
        const verifyResponse = await axios.get(
          `https://payment-lenco-api.onrender.com/api/payment/verify/${referenceId}`
        );

        if (
          verifyResponse.data.status === true &&
          verifyResponse.data.data.status === "successful"
        ) {
          // ✅ Payment succeeded
          const startDate = new Date();
          const endDate = new Date();

          // set duration
          const duration = selectedPlan?.duration;
          if (duration === "Daily") {
            endDate.setDate(endDate.getDate() + 1);
          } else if (duration === "Weekly") {
            endDate.setDate(endDate.getDate() + 7);
          } else if (duration === "Monthly") {
            endDate.setMonth(endDate.getMonth() + 1);
          } else if (duration === "3 Months") {
            endDate.setMonth(endDate.getMonth() + 3);
          }

                   
          // format dates
          const formattedStartDate = startDate.toISOString().split("T")[0];
          const formattedEndDate = endDate.toISOString().split("T")[0];

          // update subscription
          await axios.put(
            `${process.env.REACT_APP_API_URL}/subscriptions/${referenceId}`,
            {
              startDate: formattedStartDate,
              endDate: formattedEndDate,
              active: true,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          setHasValidSubscription(true);
          localStorage.removeItem("referenceId"); // clear referenceId
          setTimeout(() => {
            navigate("/");
          }, 2000);
        } else {
          // keep polling until success
          setTimeout(verifyPayment, 5000);
        }
      } catch (error) {
        console.error("Error verifying payment:", error);
      }
    };

    // 🚀 Start verification loop
    verifyPayment();
  }, [navigate, selectedPlan]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (adminOnly) {
    if (userRole !== "admin") {
      return <Navigate to="/" />;
    }
    return children;
  }

  if (!hasValidSubscription) {
    return <Navigate to="/subscription-plans" />;
  }

  return children;
};

function App() {
  return (
    <>
      <ToastContainer position="top-right" theme="dark" />
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/subscription-plans" element={<SubscriptionPlans />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/buy-votes" element={<BuyVotes />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <LandingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <LandingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sports"
            element={
              <ProtectedRoute>
                <Sports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/live-matches"
            element={
              <ProtectedRoute>
                <LiveMatches />
              </ProtectedRoute>
            }
          />
          <Route
            path="/upcoming-matches"
            element={
              <ProtectedRoute>
                <UpcomingMatches />
              </ProtectedRoute>
            }
          />
          <Route
            path="/highlights"
            element={
              <ProtectedRoute>
                <Highlights />
              </ProtectedRoute>
            }
          />
          <Route
            path="/players"
            element={
              <ProtectedRoute>
                <Players />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clubs"
            element={
              <ProtectedRoute>
                <Clubs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/game-shows"
            element={
              <ProtectedRoute>
                <GameShows />
              </ProtectedRoute>
            }
          />
          <Route
            path="/awards"
            element={
              <ProtectedRoute>
                <Awards />
              </ProtectedRoute>
            }
          />
          <Route
            path="/voting"
            element={
              <ProtectedRoute>
                <Voting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lifestyle"
            element={
              <ProtectedRoute>
                <Lifestyle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/magazines"
            element={
              <ProtectedRoute>
                <Magazine />
              </ProtectedRoute>
            }
          />
          <Route
            path="/magazine-viewer/:id"
            element={
              <ProtectedRoute>
                <MagazineViewer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute adminOnly>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/voting/:id"
            element={
              <ProtectedRoute>
                <VotingDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/league-tables"
            element={
              <ProtectedRoute>
                <LeagueTables />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stats"
            element={
              <ProtectedRoute>
                <Stats />
              </ProtectedRoute>
            }
          />
          <Route path="/gameshow/:id" element={<GameShowDetail />} />
          <Route
            path="/sports/club/:id"
            element={
              <ProtectedRoute>
                <ClubPlayers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sports/coach/:id"
            element={
              <ProtectedRoute>
                <CoachDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/news"
            element={
              <ProtectedRoute>
                <News />
              </ProtectedRoute>
            }
          />
          <Route
            path="/news/:id"
            element={
              <ProtectedRoute>
                <NewsDetail />
              </ProtectedRoute>
            }
          />

          {/* DESAC Sports routes */}
          <Route
            path="/desac-sports"
            element={
              <ProtectedRoute>
                <DesacSports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/desac-sports/rising-stars-registration"
            element={
              <ProtectedRoute>
                <RisingStarsRegistration />
              </ProtectedRoute>
            }
          />
          <Route
            path="/desac-sports/registration-success"
            element={
              <ProtectedRoute>
                <RegistrationSuccess />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
